{
  "version": 1,
  "asset_id": "006ee3e6-8b3a-4167-a602-4bcc795d0067",
  "project_id": "7d1776ab-cb36-43c5-a7cd-acaad4e00de7",
  "url": "/__l5e/assets-v1/006ee3e6-8b3a-4167-a602-4bcc795d0067/OP2P-CRM-e-Agentes-de-IA-logotipo-branco-2026.webp",
  "r2_key": "a/v1/7d1776ab-cb36-43c5-a7cd-acaad4e00de7/006ee3e6-8b3a-4167-a602-4bcc795d0067/OP2P-CRM-e-Agentes-de-IA-logotipo-branco-2026.webp",
  "original_filename": "OP2P-CRM-e-Agentes-de-IA-logotipo-branco-2026.webp",
  "size": 26404,
  "content_type": "image/webp",
  "created_at": "2026-08-31T20:14:37Z"
}
